export default function safeJsonParse(json, defaultValue) {
    try {
        return JSON.parse(json) ?? defaultValue
    } catch (e) {
        return defaultValue
    }
}
